module.exports = __webpack_public_path__ + "img/character-robot-happy.fa541d5a.svg";